import PrintsTableReducer from "./reducers/PrintsTableReducer";
import PrintsSaga from "./saga";

import IConfig from "interfaces/IConfig";
import store from "rootStore";
import { permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";

export const moduleName = "print.prints";
export const url = "prints";

const getConfig = (permissions: permissionsType, parentUrl: string) => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };

    let routing: routingType = [];

    if (permissions["print.prints.read"]) {
        config.active = true;

        store.reducerManager?.add("PrintPrintTable", PrintsTableReducer);
        store.injectSaga?.("PrintPrintsSaga", PrintsSaga);

        routing.push({
            path: url,
            element: (
                <AsyncComponent path="Print/Prints/pages/PrintsIndexPage" />
            ),
        });
        routing.push({
            path: `${url}/:id`,
            element: (
                <AsyncComponent path="Print/Prints/pages/PrintShowPage" />
            ),
        });
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => parentUrl + "/" + item.path);
    }

    return { config, routing };
};

export default getConfig;
